import script from "./case_purchase_view.vue?vue&type=script&setup=true&lang=js"
export * from "./case_purchase_view.vue?vue&type=script&setup=true&lang=js"

import "./case_purchase_view.vue?vue&type=style&index=0&id=2031b4ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2031b4ae"]])

export default __exports__